<template>
  <div class="">
    <b-navbar toggleable="md" type="dark" variant="info" class="pt-0 pb-0">
      <div class="container">
        <b-navbar-toggle target="nav_collapse_docentes"></b-navbar-toggle>
        <h1 class="text-center navbar-brand pt-0 pb-0 mb-0">Cambiar Password</h1>
        <b-collapse is-nav id="nav_collapse_docentes">
          <b-navbar-nav class="ml-auto">
            <b-nav-item href="#" @click="procesarCancelar">Cancelar</b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </div>
    </b-navbar>

    <div class="container pt-4 m-auto text-left">
      <div class="row justify-content-center">
        <div class="col-lg-8">
          <!-- Card Principal -->
          <div class="password-card">
            <div class="card-header-custom">
              <i class="fa fa-key mr-2"></i>
              <h4 class="mb-0">Cambiar Contraseña</h4>
            </div>

            <div class="card-body-custom">
              <!-- Selector de Tipo -->
              <div class="section-card mb-4">
                <h5 class="section-title">
                  <i class="fa fa-cog mr-2"></i>Tipo de contraseña
                </h5>
                <div class="password-selector">
                  <div 
                    class="password-option" 
                    :class="{ 'active': tipoPassword === 'automatica' }"
                    @click="tipoPassword = 'automatica'"
                  >
                    <div class="radio-custom">
                      <div class="radio-inner" v-if="tipoPassword === 'automatica'"></div>
                    </div>
                    <div class="option-content">
                      <i class="fa fa-magic option-icon text-primary"></i>
                      <div>
                        <strong>Automática</strong>
                        <p class="mb-0 text-muted small">Generar contraseña segura automáticamente</p>
                      </div>
                    </div>
                  </div>
                  
                  <div 
                    class="password-option" 
                    :class="{ 'active': tipoPassword === 'manual' }"
                    @click="tipoPassword = 'manual'"
                  >
                    <div class="radio-custom">
                      <div class="radio-inner" v-if="tipoPassword === 'manual'"></div>
                    </div>
                    <div class="option-content">
                      <i class="fa fa-edit option-icon text-success"></i>
                      <div>
                        <strong>Manual</strong>
                        <p class="mb-0 text-muted small">Establecer contraseña personalizada</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Input Manual (solo si es manual) -->
              <div v-if="tipoPassword === 'manual'" class="section-card mb-4">
                <h5 class="section-title">
                  <i class="fa fa-lock mr-2"></i>Nueva contraseña
                </h5>
                <div class="password-input-wrapper">
                  <input 
                    type="text"
                    v-model="password"
                    name="password"
                    placeholder="Ingresa la nueva contraseña"
                    class="form-control-custom"
                  >
                  <div class="password-hint">
                    <i class="fa fa-info-circle mr-1"></i>
                    Debe tener mínimo 8 caracteres
                  </div>
                </div>
              </div>

              <!-- Información del Docente -->
              <div class="info-box mb-4">
                <div class="info-icon">
                  <i class="fa fa-envelope"></i>
                </div>
                <div class="info-text">
                  <strong>Correo de notificación:</strong>
                  <p class="mb-0">{{ docente?.email }}</p>
                  <small class="text-muted">Se enviará la nueva contraseña a este correo electrónico</small>
                </div>
              </div>

              <!-- Botones de Acción -->
              <div class="action-buttons">
                <button 
                  type="button"
                  class="btn btn-outline-secondary btn-lg"
                  @click="procesarCancelar"
                >
                  <i class="fa fa-times mr-2"></i>Cancelar
                </button>
                <button 
                  type="button"
                  class="btn btn-primary btn-lg"
                  @click="procesarCambiarPassword"
                  :disabled="tipoPassword === 'manual' && (!password || password.length < 8)"
                >
                  <i class="fa fa-check mr-2"></i>Cambiar Contraseña
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState, mapActions, mapMutations} from 'vuex';

  export default {
    name: 'DocenteCambiarPassword',
    components: {
    },
    data () {
      return {
           docente_id: null,
           password: '',
           tipoPassword: 'automatica'
      }
    },
    mounted () {
     this.docente_id = this.$route.params.id;
      if(!this.detalle[this.docente_id]){
        this.actualizar()
      }
    },
    
    methods:{
      ...mapActions({
        fetchDetalle: 'docentes/fetchDetalle',
        editar: 'docentes/editar',
        setWarning: 'setWarning',
        cambiarPassword: 'asw/cambiarPassword'
      }),
      ...mapMutations({
        
      }),
      procesarCancelar(){
        this.fetchDetalle(this.docente_id).then(()=>{
          this.$router.push('/docente/detalle/'+this.docente_id)
        })
      },
      actualizar(){
        this.fetchDetalle(this.docente_id)
      },
      
      procesarCambiarPassword () {
        // Si es automática, enviar action autogenerate
        if (this.tipoPassword === 'automatica') {
          this.cambiarPassword({userid: this.docente_id, action: 'autogenerate'})
            .then(data => {
              this.setWarning(data.mensaje, { root: true }).then(() => {
                this.$router.push('/docente/detalle/' + this.docente_id)
              })
            })
            .catch(error => {
              this.setWarning(error, { root: true }).then(() => {})
            })
        } 
        // Si es manual, validar y enviar password
        else {
          if (!this.password || this.password === '') {
            this.setWarning('Por favor, ingresa una contraseña.', { root: true })
            return
          }
          if (this.password.length < 8) {
            this.setWarning('La contraseña debe tener mínimo 8 caracteres.', { root: true })
            return
          }
          
          this.cambiarPassword({userid: this.docente_id, password: this.password})
            .then(data => {
              this.setWarning(data.mensaje, { root: true }).then(() => {
                this.$router.push('/docente/detalle/' + this.docente_id)
              })
            })
            .catch(error => {
              this.setWarning(error, { root: true }).then(() => {})
            })
        }
      }


    },
    computed:{
      ...mapState({
        detalle: state => state.docentes.detalle, 
        warning: state => state.warning
      }),
      docente(){
        return this.detalle[this.docente_id]
      },
      
      
    }
    
  }
</script>

<style scoped>
.password-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  margin-bottom: 30px;
}

.card-header-custom {
  background: linear-gradient(135deg, #0D4E8C 0%, #0a3a6b 100%);
  color: white;
  padding: 25px 30px;
  display: flex;
  align-items: center;
}

.card-header-custom i {
  font-size: 24px;
}

.card-header-custom h4 {
  font-weight: 600;
  margin: 0;
}

.card-body-custom {
  padding: 30px;
}

.section-card {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 20px;
  border: 1px solid #e9ecef;
  transition: all 0.3s ease;
}

.section-card:hover {
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

/* Password Selector */
.password-selector {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
}

.password-option {
  background: white;
  border: 2px solid #e9ecef;
  border-radius: 10px;
  padding: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: flex-start;
  gap: 15px;
}

.password-option:hover {
  border-color: #0D4E8C;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(13, 78, 140, 0.2);
}

.password-option.active {
  border-color: #0D4E8C;
  background: linear-gradient(135deg, rgba(13, 78, 140, 0.1) 0%, rgba(10, 58, 107, 0.1) 100%);
  box-shadow: 0 5px 15px rgba(13, 78, 140, 0.2);
}

.radio-custom {
  width: 24px;
  height: 24px;
  border: 2px solid #cbd5e0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.password-option.active .radio-custom {
  border-color: #0D4E8C;
}

.radio-inner {
  width: 12px;
  height: 12px;
  background: linear-gradient(135deg, #0D4E8C 0%, #0a3a6b 100%);
  border-radius: 50%;
  animation: scaleIn 0.3s ease;
}

.option-content {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
}

.option-icon {
  font-size: 28px;
}

.option-content strong {
  display: block;
  font-size: 16px;
  color: #2d3748;
  margin-bottom: 2px;
}

/* Password Input */
.password-input-wrapper {
  position: relative;
}

.form-control-custom {
  width: 100%;
  padding: 14px 18px;
  border: 2px solid #e9ecef;
  border-radius: 10px;
  font-size: 16px;
  transition: all 0.3s ease;
  background: white;
}

.form-control-custom:focus {
  outline: none;
  border-color: #0D4E8C;
  box-shadow: 0 0 0 3px rgba(13, 78, 140, 0.1);
}

.password-hint {
  margin-top: 10px;
  font-size: 14px;
  color: #718096;
  display: flex;
  align-items: center;
}

/* Info Box */
.info-box {
  background: linear-gradient(135deg, rgba(13, 78, 140, 0.05) 0%, rgba(10, 58, 107, 0.05) 100%);
  border: 1px solid rgba(13, 78, 140, 0.2);
  border-radius: 12px;
  padding: 20px;
  display: flex;
  gap: 15px;
  align-items: flex-start;
}

.info-icon {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #0D4E8C 0%, #0a3a6b 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 22px;
  flex-shrink: 0;
}

.info-text {
  flex: 1;
}

.info-text strong {
  color: #2d3748;
  font-size: 15px;
  display: block;
  margin-bottom: 5px;
}

.info-text p {
  color: #0D4E8C;
  font-weight: 600;
  font-size: 16px;
}

.info-text small {
  font-size: 13px;
}

/* Action Buttons */
.action-buttons {
  display: flex;
  gap: 15px;
  justify-content: flex-end;
  margin-top: 30px;
}

.action-buttons .btn {
  min-width: 150px;
  font-weight: 600;
  border-radius: 8px;
  padding: 12px 24px;
  transition: all 0.3s ease;
}

.btn-primary {
  background: linear-gradient(135deg, #0D4E8C 0%, #0a3a6b 100%);
  border: none;
  color: white;
}

.btn-primary:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(13, 78, 140, 0.4);
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-outline-secondary {
  border: 2px solid #e9ecef;
  color: #4a5568;
}

.btn-outline-secondary:hover {
  background: #f7fafc;
  border-color: #cbd5e0;
}

/* Animations */
@keyframes scaleIn {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}

/* Responsive */
@media (max-width: 768px) {
  .password-selector {
    grid-template-columns: 1fr;
  }
  
  .action-buttons {
    flex-direction: column;
  }
  
  .action-buttons .btn {
    width: 100%;
  }
  
  .card-body-custom {
    padding: 20px;
  }
}
</style>